module.exports = __webpack_public_path__ + "img/pic_brazil_07.55b6f32c.jpg";